/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentCreator
 */
export interface TournamentCreator {
    /**
     * 
     * @type {string}
     * @memberof TournamentCreator
     */
    name: string;
}

/**
 * Check if a given object implements the TournamentCreator interface.
 */
export function instanceOfTournamentCreator(value: object): value is TournamentCreator {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TournamentCreatorFromJSON(json: any): TournamentCreator {
    return TournamentCreatorFromJSONTyped(json, false);
}

export function TournamentCreatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentCreator {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function TournamentCreatorToJSON(value?: TournamentCreator | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

